import JSZip from "jszip";
import { useState } from "react";
import { Zlib } from "react-zlib-js";
import Swal from "sweetalert2";
import { descargarDocumentos } from "../../utils/Datos";

const DescargarDocumentos = ({ id_process, name, yearProcess }) => {
  let id_ = "#mdl_" + id_process;
  let id = "mdl_" + id_process;
  const [cargando, setCargando] = useState(false);

  async function dataUrlToFile(dataUrl, nombre, tipo) {
    const res = await fetch(dataUrl);
    const blob = await res.blob();
    return new File([blob], nombre, { type: tipo });
  }

  function descargarArchivos() {
    setCargando(true);
    descargarDocumentos(id_process).then((respuesta) => {
      if (respuesta.status) {
        Swal.fire({
          title: "Listo",
          text: "El archivo se descargará automáticamente",
          icon: "success",
          confirmButtonText: "Ok",
        });
        /*let archivo = `data:${respuesta.datos.contentType};base64,${respuesta.datos.contentByte}`;
        let a = document.createElement("a");
        a.href = archivo;
        a.download = respuesta.datos.name;
        a.click();*/

        let a = document.createElement("a");
        a.href =
          "data:" +
          respuesta.datos.contentType +
          ";base64," +
          respuesta.datos.contentByte;
        a.download = respuesta.datos.name;
        a.click();
      } else {
        Swal.fire({
          title: "Error",
          text: respuesta.errores ?? "Ocurrió un error",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      setCargando(false);
    });
  }

  return (
    <>
      <a
        href="#/"
        className="btn btn-sm btn-secondary"
        data-bs-toggle="modal"
        data-bs-target={id_}
      >
        <i className="fas fa-download"></i>
      </a>

      <div className="modal fade" id={id} tabIndex="-1" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered mw-900px">
          <div className="modal-content">
            <div className="modal-header">
              <h2> Descargar calificaciones #{id_process}</h2>

              <div
                className="btn btn-sm btn-icon btn-active-color-primary"
                data-bs-dismiss="modal"
              >
                <span className="svg-icon svg-icon-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <rect
                      opacity="0.5"
                      x="6"
                      y="17.3137"
                      width="16"
                      height="2"
                      rx="1"
                      transform="rotate(-45 6 17.3137)"
                      fill="currentColor"
                    />
                    <rect
                      x="7.41422"
                      y="6"
                      width="16"
                      height="2"
                      rx="1"
                      transform="rotate(45 7.41422 6)"
                      fill="currentColor"
                    />
                  </svg>
                </span>
              </div>
            </div>

            <div className="modal-body py-lg-10 px-lg-10">
              <div className="border border-gray-300 border-dashed rounded min-w-80px py-3 px-4 mx-2 mb-3">
                <div className="fs-6 fw-bolder text-gray-700">{name}</div>
                <div className="fw-bold text-gray-400">Año {yearProcess}</div>
              </div>

              <div className="notice d-flex bg-light-primary rounded border-primary border border-dashed h-lg-100 p-6">
                <div className="d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap">
                  <div className="mb-3 mb-md-0 fw-bold">
                    <h4 className="text-gray-900 fw-bolder">¡Importante!</h4>
                    <div className="fs-6 text-gray-700 pe-7">
                      ¿Descargar todos los documentos de este proceso?
                      <br /> Este proceso puede tardar unos minutos.
                      <br /> Favor no cierre la ventana hasta que termine.
                    </div>
                  </div>
                  <button
                    onClick={descargarArchivos}
                    className="btn btn-primary px-6 align-self-center text-nowrap"
                    disabled={cargando}
                  >
                    {cargando
                      ? " Generando Documentos..."
                      : " Descargar Calificaciones"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DescargarDocumentos;
